import React from 'react';
import cn from 'classnames';
import { withRouter } from 'react-router';
import PopOver from 'chameleon/ui-stack/ui/base/popover';
import './AssignmentSection.scss';
import StudentSettingsData from './StudentSettingsData';

const AssignmentSection = (props) => {
  const {
    sectionName,
    subGroupStudents,
    noDataPlaceholder,
    className,
    removeMargin,
    disableStudentsPopover = false,
    children,
    assignment,
    studentsBySection,
    isSPP,
  } = props;
  const hasLinkToStudentsPopover = subGroupStudents.length > 1;
  const hasLinkToStudentSettingsPopover =
    assignment?.student_settings?.length > 0;

  if (!sectionName) {
    return noDataPlaceholder;
  }
  let SubgroupData = () => null;
  if (subGroupStudents && subGroupStudents.length > 0) {
    if (subGroupStudents.length === 1) {
      const { first_name = '', last_name = '' } = subGroupStudents[0] || {};
      SubgroupData = () => (
        <p data-drag-element className="mt-0 mb-1" data-row-click="true">
          {`${first_name} ${last_name}`}
        </p>
      );
    } else {
      SubgroupData = () => (
        <PopOver
          className={cn('SubGroupAssignmentPopover', {
            interactive: !disableStudentsPopover,
          })}
          trigger={`(${subGroupStudents.length} Students)`}
          disabled={disableStudentsPopover}
        >
          <div>
            <p data-drag-element className="section-name font-medium">
              {sectionName}
            </p>
            {subGroupStudents.map((student, i) => (
              <p key={i} className="font-normal">
                {`${(student || {}).first_name} ${(student || {}).last_name}`}
              </p>
            ))}
          </div>
        </PopOver>
      );
    }
  }

  return (
    <div>
      {children}
      <div
        className={cn(
          'items-center font-normal text-14',
          {
            'ml-18': !removeMargin,
            'flex flex-nowrap':
              hasLinkToStudentsPopover || hasLinkToStudentSettingsPopover,
          },
          className,
        )}
      >
        {subGroupStudents.length !== 1 && (
          <p
            data-drag-element
            className="flex items-end m-0 mr-2"
            data-row-click="true"
          >
            {sectionName}
          </p>
        )}
        {subGroupStudents.length > 0 && (
          <div className={cn('my-0 mr-4')}>
            <SubgroupData />
          </div>
        )}
        {assignment?.student_settings?.length > 0 && (
          <div className={cn('my-0')}>
            <StudentSettingsData
              assignment={assignment}
              studentsBySection={studentsBySection}
              isSPP={isSPP}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default withRouter(AssignmentSection);
